module.exports = __webpack_public_path__ + "static/banner-5d06378d301edd9555c104924dcea5a2.jpg";